export default {
    path: '',
    component: () => import(`@/page/distributor/component/basic-layout/1.0.4/index.vue`),
    children: [
      {
        path: '/air-ticket',
        component: () => import('@/page/distributor/component/admin-layout/index.vue'),
        children: [
          {
            path: 'chang-payment',
            name: 'air-chang-payment',
            component: () => import('./index.vue'),
            meta: {
              nav_list_for_admin_layout_head_nav: [
                {name: `机票`},
                {name: `改签补款`},
              ],
            },
          },
        ]
      }
    ]
  };
